function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 304,
  height: 192,
  rx: 12,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M178.5 56.2511C164.1 59.7511 155 69.4511 155 81.3511C155 90.2511 159.7 96.0511 172.4 103.151C176.8 105.551 181.3 108.751 182.4 110.251C184.3 112.751 184.3 113.151 182.9 115.651C180.5 119.951 177.5 120.951 168 120.551C162.2 120.351 158 119.551 154.8 118.151L150.2 116.051L148.5 123.651C147.6 127.951 146.8 131.951 146.7 132.751C146.3 135.451 154.7 137.151 169 137.251C181.8 137.351 182.8 137.251 188.5 134.551C201.6 128.451 208 117.151 205 105.751C203.3 99.3511 199.8 95.4511 191.7 90.7511C177 82.2511 176.8 82.0511 177.2 78.5511C177.7 73.6511 182.4 71.5511 191.6 72.1511C195.4 72.4511 200.3 73.3511 202.2 74.1511L205.9 75.6511L206.9 70.7511C207.5 68.1511 208.3 64.1511 208.6 61.9511L209.2 58.0511L202.2 56.4511C194 54.5511 185.6 54.5511 178.5 56.2511Z",
  fill: "#1A1F71"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M22 57.751C22 58.251 24.6 59.451 27.8 60.351C37.3 63.051 44.1 66.051 45.5 68.251C46.2 69.451 50.2 83.851 54.5 100.351C58.7 116.851 62.6 131.851 63.1 133.651L64.2 136.951L75.2 136.651L86.2 136.351L102.1 98.451C110.8 77.651 118.2 59.751 118.5 58.751C119.1 56.951 118.4 56.851 108.3 56.851H97.5L87 83.351C81.3 97.851 76.4 109.551 76.2 109.351C76 109.151 73.8 98.551 71.4 85.851C69 73.151 66.6 61.951 66 60.851C65.4 59.751 64.1 58.451 63 57.851C60.6 56.551 22 56.451 22 57.751Z",
  fill: "#1A1F71"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M119.8 96.551L111.3 136.351L121.3 136.651C126.8 136.751 131.5 136.651 131.8 136.351C132.2 135.951 148.9 59.651 149 57.551C149 57.151 144.4 56.851 138.7 56.851H128.3L119.8 96.551Z",
  fill: "#1A1F71"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M238.9 58.1511C238 58.8511 236.8 60.2511 236.3 61.3511C234.8 64.0511 205.9 132.851 205.3 135.051C204.8 136.651 205.8 136.851 215.7 136.851H226.5L228.5 131.051L230.5 125.351H244C256.7 125.351 257.5 125.451 257.8 127.351C258 128.451 258.6 131.051 259.1 133.051L260.1 136.851H269.7C278.3 136.851 279.2 136.651 278.8 135.051C278.6 134.151 274.8 116.151 270.4 95.1511L262.5 56.8511H251.5C244.4 56.9511 239.9 57.3511 238.9 58.1511ZM250.9 94.1511L253.8 107.851H245.3C237.6 107.851 236.9 107.651 237.5 106.051C237.9 105.151 239.9 99.6511 242 93.8511C246.9 80.3511 247.2 79.6511 247.6 80.1511C247.8 80.3511 249.3 86.6511 250.9 94.1511Z",
  fill: "#1A1F71"
});

var SvgVisa = function SvgVisa(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 304,
    height: 192,
    viewBox: "0 0 304 192",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVisa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/visa.b86c15fc.svg";
export { ForwardRef as ReactComponent };